import React from "react";
import {
  TimelineItem as SaasTimelineItem,
  TimelineItemProps as SaasTimelineItemProps,
} from "@saas-ui/react";
import { SystemStyleObject, forwardRef } from "@chakra-ui/react";

type IconAlign = "top" | "center" | "bottom";

export type TimelineItemProps = SaasTimelineItemProps & {
  iconAlign?: IconAlign;
};

const collapsedSpacerSx: SystemStyleObject = {
  flex: 0,
  minH: 0,
};

const iconAlignSx: Record<IconAlign, SystemStyleObject> = {
  center: {
    "& .sui-timeline__content": {
      paddingTop: "3px",
      paddingBottom: "3px",
    },
  },
  top: {
    alignItems: "start",
    "& .sui-timeline__content": {
      paddingTop: "3px",
      paddingBottom: "3px",
    },
    "& .sui-timeline__separator": {
      alignSelf: "start",
      justifyContent: "flex-start",
      transform: "translateY(-2px)",
    },
    "& .sui-timeline__separator::before": collapsedSpacerSx,
    "& .sui-timeline__track:first-of-type": collapsedSpacerSx,
  },
  bottom: {
    alignItems: "end",
    "& .sui-timeline__content": {
      paddingTop: "3px",
      paddingBottom: "3px",
    },
    "& .sui-timeline__separator": {
      alignSelf: "flex-end",
      justifyContent: "flex-end",
      transform: "translateY(2px)",
    },
    "& .sui-timeline__separator::after": collapsedSpacerSx,
    "& .sui-timeline__track:last-of-type": collapsedSpacerSx,
  },
};

export const TimelineItem = forwardRef<TimelineItemProps, "li">(
  ({ iconAlign = "center", sx, ...rest }, ref) => {
    return (
      <SaasTimelineItem
        ref={ref}
        sx={{ ...iconAlignSx[iconAlign], ...sx }}
        {...rest}
      />
    );
  }
);

TimelineItem.displayName = "TimelineItem";
